import gsap from "gsap";
import { createApp } from 'vue';
import ReviewsMain from '@/js/sections/ReviewsMain.vue';

const reviewsMainRoots = document.querySelectorAll('[data-vue-reviews-main]');

if (reviewsMainRoots.length) {
	reviewsMainRoots.forEach((root) => {
		const reviewsUrl = root.dataset.reviewsUrl;
		createApp(ReviewsMain, { reviewsUrl }).mount(root);
	});
}

class DeviceSpecs {
	constructor() {
		this.root = document.querySelector('.reviews');

		this.config = {
			allowMultipleExpanded: true
		};

		this.classes = {
			expanded: 'is-expanded',
			active: 'is-active'
		};

		this.selectors = {
			tab: '.reviews__tab',
			slide: '.reviews__slide',
			item: '.faq__item',
			heading: '.faq__heading',
			button: '.faq__heading',
			content: '.faq__content'
		};

		this.animation = {
			duration: 0.3
		};

		this.currentItem = null;
		this.pendingToggle = null;
		this.tabs = this.root ? this.root.querySelectorAll(this.selectors.tab) : [];
		this.slides = this.root ? this.root.querySelectorAll(this.selectors.slide) : [];

		this.items = this.root ? this.root.querySelectorAll(this.selectors.item) : [];
	}

	setActiveSlideByTab(index) {
		if (!this.tabs.length || !this.slides.length) return;

		this.tabs.forEach((tab, tabIndex) => {
			tab.classList.toggle(this.classes.active, tabIndex === index);
		});

		this.slides.forEach((slide, slideIndex) => {
			slide.classList.toggle(this.classes.active, slideIndex === index);
		});
	}

	initTabs() {
		if (!this.tabs.length || !this.slides.length) return;

		let initialIndex = 0;
		this.tabs.forEach((tab, index) => {
			if (tab.classList.contains(this.classes.active)) {
				initialIndex = index;
			}

			tab.addEventListener('click', () => {
				this.setActiveSlideByTab(index);
			});
		});

		this.setActiveSlideByTab(initialIndex);
	}

	setExpanded() {
		if (!this.pendingToggle) return;

		const { item, button, content, isExpanded } = this.pendingToggle;
		item.classList.toggle(this.classes.expanded, isExpanded);

		gsap.to(content, {
			height: isExpanded ? 'auto' : 0,
			opacity: isExpanded ? 1 : 0,
			duration: this.animation.duration,
			onComplete: () => {
				button.setAttribute('aria-expanded', String(isExpanded));
				content.setAttribute('aria-hidden', String(!isExpanded));
			}
		});
	}

	collapseOtherItems() {
		this.items.forEach((item) => {
			if (item === this.currentItem || !item.classList.contains(this.classes.expanded)) return;

			const button = item.querySelector(this.selectors.button);
			const content = item.querySelector(this.selectors.content);

			if (!button || !content) return;

			this.pendingToggle = {
				item,
				button,
				content,
				isExpanded: false
			};

			this.setExpanded();
		});
	}

	init() {
		this.initTabs();

		if (!this.items.length) return;

		this.items.forEach((item) => {
			const heading = item.querySelector(this.selectors.heading);
			const button = item.querySelector(this.selectors.button);
			const content = item.querySelector(this.selectors.content);

			if (!heading || !button || !content) return;

			button.setAttribute('aria-expanded', 'false');
			content.setAttribute('aria-hidden', 'true');

			heading.addEventListener('click', () => {
				const isExpanded = !item.classList.contains(this.classes.expanded);
				this.currentItem = item;

				if (!this.config.allowMultipleExpanded && isExpanded) {
					this.collapseOtherItems();
				}

				this.pendingToggle = {
					item,
					button,
					content,
					isExpanded
				};

				this.setExpanded();
			});
		});
	}
}

new DeviceSpecs().init();